import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getVanityAdmin, addVanityImage, deleteVanityImage } from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

export default function AdminVanity() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  const load = () => getVanityAdmin().then(d => { setItems(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleFile = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try {
      for (const file of files) {
        const url = await uploadToCloudinary(file);
        await addVanityImage({ url, order: items.length });
      }
      await load();
    } catch { alert('Upload failed'); }
    finally { setUploading(false); e.target.value = ''; }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove?')) return;
    await deleteVanityImage(id);
    setItems(p => p.filter(x => x.id !== id));
  };

  return (
    <AdminLayout title="Vanity Images">
      <div className="admin-section">
        <div className="admin-section-header">
          <h2>Insight to Our Vanity — Scroll Row Images</h2>
          <label className="a-btn a-btn-accent" style={{ cursor: 'pointer' }}>
            {uploading ? 'Uploading…' : '+ Upload Images'}
            <input type="file" accept="image/*" multiple onChange={handleFile} style={{ display: 'none' }} disabled={uploading} />
          </label>
        </div>
        <div className="admin-section-body">
          {loading ? <div className="admin-spinner">Loading…</div> : (
            items.length === 0 ? <div className="admin-empty">No images yet</div> : (
              <div className="admin-gallery-grid">
                {items.map(item => (
                  <div key={item.id} className="admin-gallery-item">
                    <img src={item.url} alt="" />
                    <div className="delete-overlay"><button onClick={() => handleDelete(item.id)}>Remove</button></div>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
